// extracted by mini-css-extract-plugin
export default {"pageSpin":"index_pageSpin__M+qtc","inDisabledLayout":"index_inDisabledLayout__BSG4p"};